// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/reports/payroll/net-pay-listing',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/net-pay-listing.vue'),
        name: 'reports.payroll.net-pay-listing',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-net-pay-listing-report',
        },
    },

    {
        path: '/:organisation/reports/payroll/gross-pay-listing',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/gross-pay-listing.vue'),
        name: 'reports.payroll.gross-pay-listing',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-gross-pay-listing-report',
        },
    },

    {
        path: '/:organisation/reports/payroll/payroll-summary-register',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/payroll-summary-register.vue'),
        name: 'reports.payroll.payroll-summary-register',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-payroll-summary-register',
        },
    },

    {
        path: '/:organisation/reports/payroll/statutory-deductions-register',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/statutory-deductions-register.vue'),
        name: 'reports.payroll.statutory-deductions-register',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-statutory-deductions-register',
        },
    },
    {
        path: '/:organisation/reports/payroll/non-statutory-deductions-register',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/non-statutory-deductions-register.vue'),
        name: 'reports.payroll.non-statutory-deductions-register',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-non-statutory-deductions-register',
        },
    },

    {
        path: '/:organisation/reports/payroll/pension-contribution-report',
        component: () =>
            import('@/pages/[organisation]/reports/payroll/pension-contribution-report.vue'),
        name: 'reports.payroll.pension-contribution-report',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payroll.generate-pension-contribution-report',
        },
    },
];
